module.exports = [{"name":"צפון אמריקה","Land":"North America","bubbles":4},{"name":"דרום אמריקה","Land":"South America","bubbles":4},{"name":"אירופה","Land":"Europe","bubbles":4},{"name":"אפריקה","Land":"Africa","bubbles":4},{"name":"המזרח התיכון","Land":"Middle East","bubbles":3},{"name":"אסיה","Land":"Asia","bubbles":4},{"name":"אוקיאניה","Land":"Australia","bubbles":2}]


//////////////////
// WEBPACK FOOTER
// ./src/static/api/data.json
// module id = 45
// module chunks = 0